/**
 * Feature flag utilities for PrimeShine application
 */

/**
 * Check if Housepro booking flow should be used
 * @returns {boolean} True if Housepro flow should be used
 */
export const isHouseproBookingEnabled = () => {
  return process.env.REACT_APP_FEATUREFLIP_HOUSEPRO === '1';
};

/**
 * Get the appropriate booking flow component path
 * @returns {string} The path to navigate to for booking
 */
export const getBookingFlowPath = () => {
  return isHouseproBookingEnabled() ? '/housepro-booking' : '/booking';
};

/**
 * Feature flags configuration object
 */
export const featureFlags = {
  houseproBooking: isHouseproBookingEnabled(),
};

export default featureFlags;